<template>
  <div class="w-full h-full mt-10px">
    <categoryTitle title="区域风险信息统计" />
    <div class="mt-10px mx-10px flex justify-between">
      <div class="flex items-center">
        <img src="../../../assets/images/risk/riskPoint.png" />
        <div class="text-[#fff] ml-10px">
          <p class="font-bold text-center mb-10px text-18px">{{ form.evaluationCount }}</p>
          <p class="text-12px text-center">识别风险点数量</p>
        </div>
      </div>
      <div class="flex items-center">
        <img src="../../../assets/images/risk/hazardSource.png" />
        <div class="text-[#fff] ml-10px">
          <p class="font-bold text-center mb-10px text-18px">{{ form.sourceCount }}</p>
          <p class="text-12px text-center">辨识危险源数量</p>
        </div>
      </div>
    </div>
    <div class="flex mt-20px mx-10px mb-10px">
      <dataCard title="高风险" :num="form.lowCount" color="#f12f1e" class="flex-1 mr-15px" />
      <dataCard title="中风险" :num="form.middleCount" color="#ff8a00" class="flex-1 mr-15px" />
      <dataCard title="低风险" :num="form.highCount" color="#46f9ff" class="flex-1" />
    </div>
    <categoryTitle title="区域风险管控详情" />
    <el-input
      placeholder="设备名称"
      v-model="deviceName"
      size="small"
      clearable
      @keypress.enter.native="searchList"
      class="icon-search__input mt-10px w-200px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="searchList"
      ></i>
    </el-input>
    <div class="mt-10px h-[calc(100%-276px)]">
      <el-table :data="tableData" height="100%" @row-click="rowClick" empty-text="暂无作业信息">
        <el-table-column prop="device" label="系统" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="systemName" label="所属设备" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sourceCount" label="危险源" show-overflow-tooltip width="80px">
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center mt-10px">
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="page.pageNo"
        :page-size.sync="page.pageSize"
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <riskAreaEvalutionDialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :deviceName="currentRow.device"
      :areaManagementAreaId="transferProps ? transferProps.areaDetail.id : ''"
    />
  </div>
</template>

<script>
import { RiskAreaEvaluationApi } from '@wiz-api/huizhou2-business'
import dataCard from '@/components/cockpit/DataCard'
import categoryTitle from '@/components/cockpit/CategoryTitle'

const riskAreaEvaluationApi = new RiskAreaEvaluationApi()
const riskAreaEvalutionDialog = () => {
  return import('./components/RiskAreaEvalutionDialog')
}
export default {
  name: 'risk-area-detail',
  components: {
    categoryTitle,
    dataCard,
    riskAreaEvalutionDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      form: {
        lowCount: 0,
        middleCount: 0,
        highCount: 0,
        sourceCount: 0,
        evaluationCount: 0,
      },
      deviceName: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      dialogVisible: false,
      currentRow: {},
    }
  },
  watch: {
    transferProps: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal?.areaDetail?.id !== oldVal?.areaDetail?.id) {
          this.getRiskEvaluationCount()
          this.searchList()
        }
      },
    },
  },
  methods: {
    async getRiskEvaluationCount() {
      const [err, res] = await riskAreaEvaluationApi.getCountByAreaManagementAreaId({
        areaManagementAreaId: this.transferProps.areaDetail.id,
      })
      if (!err && res) {
        this.form = res
      }
    },
    openStatistics() {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'RiskAreaEvalutionStatistics',
            origin: 'tag',
            name: '区域风险分级管控清单',
          },
          type: 'tags',
          props: {
            areaDetail: this.transferProps.areaDetail,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      const [err, res] = await riskAreaEvaluationApi.getCountByPage({
        areaManagementAreaId: this.transferProps.areaDetail.id,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        device: this.deviceName,
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
    rowClick(row) {
      this.currentRow = row
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  .el-form-item {
    margin-bottom: 0px;
    .el-form-item__label,
    .el-form-item__content {
      line-height: 28px;
      color: #fff;
    }
  }
}

::v-deep .el-table {
  .el-table__empty-block {
    flex-direction: column;
    .el-table__empty-text {
      line-height: unset;
      color: #fff;
      display: block;
      margin-top: 5px;
    }
    &::before {
      background: url('../../../assets/images/box.png') no-repeat center;
      background-size: 100% 100%;
      height: 64px;
      width: 64px;
    }
  }
}
</style>
